const DeviceMenu = () => {
    /* Responsive Navigation */
    const hamBurger = document.querySelector('.hamburger');
    const mbnav = document.querySelector('.mbnav');
    const overlay = document.querySelector('.mbnav__backdrop');
    const menuWrap = document.querySelector('.mbnav .menu-wrap');
    if (mbnav) {
        const menuClose = () => {
            hamBurger.classList.remove('is-clicked');
            document.body.classList.remove('scroll-fixed');
            mbnav.classList.remove('is-open');
            if (menuWrap) {
                const menuItems = menuWrap.querySelectorAll('li');
                menuItems.forEach((item) => item.classList.remove('is-open'));
                document.querySelector('.mbnav__inner > .menu-wrap').style.setProperty('--leftSlide', '0');
            }
        };

        /* Mobile overlay click */
        overlay.addEventListener('click', (e) => {
            e.stopPropagation();
            menuClose();
        });

        if (hamBurger) {
            hamBurger.addEventListener('click', function(e) {
                e.stopPropagation();
                if (hamBurger.classList.contains('is-clicked')) {
                    menuClose();
                } else {
                    hamBurger.classList.add('is-clicked');
                    mbnav.classList.add('is-open');
                    document.body.classList.add('scroll-fixed');
                }
            });
        }

        const clickable = document.querySelector('.mbnav__state') ?.getAttribute('data-clickable');

        const listItemsWithSubMenu = document.querySelectorAll('.mbnav .mbnav__main-menu li:has(ul)');
        listItemsWithSubMenu.forEach((item) => item.classList.add('has-sub'));

        const subMenus = document.querySelectorAll('.mbnav .mbnav__main-menu li > ul');
        subMenus.forEach((subMenu) => subMenu.classList.add('sub-menu'));

        const hasSubLinks = document.querySelectorAll('.mbnav .mbnav__main-menu .has-sub > a');
        hasSubLinks.forEach((link) => {
            const caret = document.createElement('em');
            caret.classList.add('mbnav__caret');
            link.after(caret);
        });

        const subMenuItems = document.querySelectorAll('.mbnav .mbnav__main-menu li:has(> ul.sub-menu)');

        subMenuItems.forEach(item => {
            const subMenu = item.querySelector(':scope > ul.sub-menu');
            if (!subMenu) {return;}

            const backClick = document.createElement('li');
            backClick.classList.add('back-click');

            const isMenuV2 = item.classList.contains('menu-v2');

            if (isMenuV2) {
                // Is this menu-v2 directly under ul.menu?
                const isTopLevelMenuV2 =
                    item.parentElement.classList.contains('menu');

                backClick.textContent = isTopLevelMenuV2
                    ? 'Back to Main Menu'
                    : 'Back';
            } else {
                backClick.textContent = 'Back';
            }

            subMenu.prepend(backClick);
        });

        if (clickable === 'true') {
            const caretElements = document.querySelectorAll('.mbnav .has-sub > .mbnav__caret');
            caretElements.forEach((caret) => caret.classList.add('mbnav__caret'));
        } else {
            const nonClickableLinks = document.querySelectorAll('.mbnav .has-sub > a');
            nonClickableLinks.forEach((link) => {
                link.classList.add('mbnav__caret');
                link.setAttribute('href', 'javascript:;');
            });
        }

        // === First part: wrapAll ===
        const menuInner = document.querySelector('.mbnav__inner');
        const children = Array.from(menuInner.children);

        const outerWrap = document.createElement('div');
        outerWrap.classList.add('menu-wrap');

        const innerWrap = document.createElement('div');
        innerWrap.classList.add('menu-inner');

        children.forEach((child) => innerWrap.appendChild(child));
        outerWrap.appendChild(innerWrap);
        menuInner.appendChild(outerWrap);

        const submenuElements = document.querySelectorAll('.mbnav__inner ul li.has-sub ul');

        submenuElements.forEach((subMenu) => {
            const parentLi = subMenu.closest('li.has-sub');

            // Is this submenu inside menu-v3?
            const menuV3 = parentLi.closest('li.menu-v3');

            if (menuV3) {
                const firstLevelUl = menuV3.querySelector(':scope > ul');

                // ❌ Skip ONLY deeper submenus inside menu-v3
                if (subMenu !== firstLevelUl) {
                    return;
                }
            }
            const menuWrap = document.createElement('div');
            menuWrap.classList.add('menu-wrap');

            const innerWrap = document.createElement('div');
            innerWrap.classList.add('menu-inner');

            subMenu.parentNode.replaceChild(menuWrap, subMenu);
            innerWrap.appendChild(subMenu);
            menuWrap.appendChild(innerWrap);
        });

        // Open menu on caret click
        const caretTriggers = document.querySelectorAll('.mbnav .has-sub > .mbnav__caret');
        caretTriggers.forEach((trigger) => {
            trigger.addEventListener('click', function(e) {
                e.stopPropagation();
                const element = this.parentElement;
                element.classList.add('is-open');
                document.body.classList.add('scroll-fixed');
                const menuLeftMove = document.querySelector('.mbnav__inner > .menu-wrap');
                const backMove = parseInt(window.getComputedStyle(menuLeftMove).getPropertyValue('--leftSlide'), 10 ) || 0;
                menuLeftMove.style.setProperty('--leftSlide', `${backMove + 100}%`);
            });
        });

        // Handle back click
        const backClicks = document.querySelectorAll('.mbnav__inner .back-click');
        backClicks.forEach((backClick) => {
            backClick.addEventListener('click', function(e) {
                e.stopPropagation();
                const menuItem = this.closest('.menu-item');
                if (menuItem) {
                    menuItem.classList.remove('is-open');
                }
                const menuLeftMove = document.querySelector('.mbnav__inner > .menu-wrap');
                const backMove = parseInt(window.getComputedStyle(menuLeftMove).getPropertyValue('--leftSlide'), 10) || 0;
                menuLeftMove.style.setProperty('--leftSlide', `${backMove - 100}%`);
            });
        });

        // Set padding from header height
        function setMenuPaddingFromHeader() {
            const menuState = document.querySelectorAll('.mbnav .mbnav__state');

            const updatePadding = () => {
                const headerHeight = document.querySelector('header.main-header').offsetHeight;

                menuState.forEach(inner => {
                    inner.style.setProperty('--headerHeight',  `${headerHeight}px`);
                });
            };

            // Set the padding initially
            updatePadding();

            // Update padding on window resize
            window.addEventListener('resize', updatePadding);
        }

        // Call the function to set padding initially
        setMenuPaddingFromHeader();
    }
};

export default DeviceMenu;